import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { intrinsicComponent } from './utils/functions';
export var RotationLeftOutline = intrinsicComponent(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 14 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M2.66029 14.6992L3.59754 14.4432L3.09234 3.93169C3.05919 3.24213 2.47333 2.71 1.78377 2.74314C1.09421 2.77628 0.562076 3.36215 0.595218 4.05171L1.16043 15.8118C1.19357 16.5014 1.77943 17.0335 2.46899 17.0004L14.2291 16.4351C14.9186 16.402 15.4508 15.8161 15.4176 15.1266C15.3845 14.437 14.7986 13.9049 14.1091 13.938L5.48449 14.3525C8.23226 7.41028 15.0052 2.5 22.925 2.5C33.2802 2.5 41.6748 10.8946 41.6748 21.2498C41.6748 22.403 41.5707 23.5319 41.3713 24.6276L43.7968 25.2605C44.0449 23.9617 44.1748 22.6209 44.1748 21.2498C44.1748 9.51386 34.6609 0 22.925 0C15.0467 0 8.16976 4.2873 4.50003 10.6561L2.66029 14.6992Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88493 34.7076L8.27775 36.6304C8.82615 37.1534 9.40249 37.6474 10.0043 38.1098L11.5276 36.1275C10.9528 35.6859 10.4044 35.2116 9.88493 34.7076Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3142 39.6562C13.9038 40.5759 15.6235 41.2956 17.439 41.7809L18.0846 39.3657C16.4846 38.938 14.9685 38.3036 13.5663 37.4923L12.3142 39.6562Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1654 42.3204C21.0738 42.4389 22.0002 42.5001 22.9408 42.5001C23.8815 42.5001 24.8079 42.4389 25.7163 42.3204L25.3929 39.8414C24.5915 39.946 23.7731 40.0001 22.9408 40.0001C22.1086 40.0001 21.2902 39.946 20.4888 39.8414L20.1654 42.3204Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4427 41.7809C30.2582 41.2956 31.9779 40.5759 33.5674 39.6562L32.3154 37.4923C30.9132 38.3036 29.3971 38.938 27.7971 39.3657L28.4427 41.7809Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8774 38.1098C37.3495 36.9786 38.6692 35.6589 39.8004 34.1868L37.8181 32.6635C36.8193 33.9633 35.6539 35.1287 34.3541 36.1275L35.8774 38.1098Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3468 31.8769C42.2665 30.2873 42.9862 28.5676 43.4715 26.7521L41.0563 26.1065C40.6286 27.7065 39.9942 29.2226 39.1829 30.6248L41.3468 31.8769Z",
    fill: color
  }));
});
export default RotationLeftOutline;